import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import './apis/httpClient/axiosInterceptor';
import mixpanel from 'mixpanel-browser';
import Layout from './layouts';

if (process.env.NODE_ENV === 'production') {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || '', {
    debug: true,
    track_pageview: true
  });
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <Layout>
      <App />
    </Layout>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
